import { useEffect, useRef, useState } from "react";
import type { RecordSaveView } from "utils/recordSaveQueue";

/**
 * The calling component as a view for RecordSaveQueue edits. It reports the scope the component
 * shows now, and stops receiving save results once the component unmounts.
 */
export function useRecordSaveView(scope: string): RecordSaveView {
  const scopeRef = useRef(scope);
  scopeRef.current = scope;
  const [view] = useState<RecordSaveView>(() => ({
    attached: true,
    currentScope: () => scopeRef.current,
  }));
  useEffect(() => {
    view.attached = true;
    return () => {
      view.attached = false;
    };
  }, [view]);
  return view;
}
